import React from 'react';
import AvatarCard from './card';

import './_avatargrid.scss';

// Mittelberger Avatar Image
import Mittelberger from '../../resources/images/avatars/mittelberger.jpg';
import Mittelberger2x from '../../resources/images/avatars/mittelberger@2x.jpg';

// Dietlein Avatar Image
import Dietlein from '../../resources/images/avatars/dietlein.jpg';
import Dietlein2x from '../../resources/images/avatars/dietlein@2x.jpg';

// Gotwald Avatar Image
import Gotwald from '../../resources/images/avatars/gotwald.jpg';
import Gotwald2x from '../../resources/images/avatars/gotwald@2x.jpg';

// Vonbank Avatar Image
import Vonbank from '../../resources/images/avatars/vonbank.jpg';
import Vonbank2x from '../../resources/images/avatars/vonbank@2x.jpg';

export default class AvatarGrid extends React.Component {
    constructor(props) {
        super(props)
        this.state = {}
    }

    render() {
        let {children, split} = this.props;
        return (
            <section className={"avatar--grid" + (split?' split':' single')}>
                <AvatarCard>
                    <img className="avatar-img" src={Gotwald} />
                    <small className="smaller">Dr. med. univ.</small>
                    <h4 className="bitlarger bold dark">Thaddäus Gotwald</h4>
                    <span className="featured small">Facharzt für medizinische<br/>Radiologie - Diagnostik</span>
                </AvatarCard>
                <AvatarCard>
                    <img className="avatar-img" src={Vonbank} />
                    <small className="smaller">Dr. med. univ.</small>
                    <h4 className="bitlarger bold dark">Herbert Vonbank</h4>
                    <span className="featured small">Facharzt für medizinische<br/>Radiologie - Diagnostik</span>
                </AvatarCard>
                <AvatarCard>
                    <img className="avatar-img" src={Mittelberger} />
                    <small className="smaller">Dr. med. univ.</small>
                    <h4 className="bitlarger bold dark">Peter Mittelberger</h4>
                    <span className="featured small">Facharzt für medizinische<br/>Radiologie - Diagnostik</span>
                </AvatarCard>
                <AvatarCard>
                    <img className="avatar-img" src={Dietlein} />
                    <small className="smaller">Dr. med. univ.</small>
                    <h4 className="bitlarger bold dark">Matthias Dietlein</h4>
                    <span className="featured small">Facharzt für diagnostische Radiologie</span>
                </AvatarCard>
            </section>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/avatargrid/index.jsx